import React from 'react';
import gifs from '../../assets/icons/gifs.json';
import { useAuth } from '../../context/AuthContext';
import { dictionary } from '../../utils/dictionary';

const CancelMessage: React.FC = () => {
  const { language } = useAuth();


  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
      }}
    >
      <div
        style={{
          width: 125.95,
          height: 125.95,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          style={{ width: 124.9, height: 124.9 }}
          src={gifs.error}
          alt="cancel-icon"
        />
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 5,
        }}
      >
        <div
          style={{
            width: 214.86,
            textAlign: 'center',
            color: '#2C3BA9',
            fontSize: 20,
            fontFamily: 'Inter, Arial, sans-serif',
            fontWeight: 700,
            lineHeight: '26px',
          }}
        >
          {dictionary["sorry"][language]}
        </div>
        <div
          style={{
            width: 214.86,
            textAlign: 'center',
            color: '#2C3BA9',
            fontSize: 16,
            fontFamily: 'Inter, Arial, sans-serif',
            fontWeight: 500,
            lineHeight: '20px',
            letterSpacing: 0.15,
          }}
        >
          {dictionary["error-update-plan"][language]}
        </div>
      </div>
    </div>
  );
};

export default CancelMessage;
